import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MarkerService {
  constructor(private http: HttpClient) {}

  getCoordinates(filePath: string): Observable<{ lat: number; lng: number }> {
    return this.http.get(filePath, { responseType: 'text' }).pipe(
        map(data => {
          const lines = data.split('\n');
          const lat = parseFloat(lines[0]);
          const lng = parseFloat(lines[1]);
          return { lat, lng };
        })
    );
  }

}